module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "cover"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COVER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "titlepage"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TITLE PAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COPYRIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-dedication",
    attrs: {
      "id": "toc-dedication"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/dedication"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-prologue"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/prologue"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("CHAPTER ONE: BROKEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_vm._v("CHAPTER TWO: THE BODY REMEMBERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter003"
    }
  }, [_vm._v("CHAPTER THREE: ENGINEERED PERFECTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR: REDACTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE: DISGUSTING PRISONERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX: ZERO PROSPECTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN: REUNITED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT: TOO CLOSE TO THE SUN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE: SUITED AND REBOOTED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN: RESURRECTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN: BACK IN THE GAME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE: BURY THE DEAD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN: THE HARBINGER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN: ASSAULT ON DARKWATER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN: A NEW SKIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN: DANGER TIME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN: DESPERATE MEASURES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN: REVEALED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINETEEN: AT WHAT COST?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY: THIS IS THE ENEMY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-ONE: SOMETIMES THEY COME BACK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-TWO: WAR THINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-THREE: SOMEONE’S DREAM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-FOUR: APPLIANCE OF SCIENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter025"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-FIVE: SCIENCE OF VIOLENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-SIX: AZIMUTH, FAITH, FIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-SEVEN: COLD RETRIBUTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-EIGHT: SLEEPER: ACTIVATED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter029"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-NINE: WARGAMES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter030"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTY: HAVE FAITH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter031"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-acknowledgements"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-appendix001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EXTRAS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-appendix002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEET THE AUTHOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-teaser",
    attrs: {
      "id": "toc-teaser001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/teaser001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PREVIEW OF "), _c('em', [_vm._v("SPLINTERED SUNS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-teaser",
    attrs: {
      "id": "toc-teaser002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/teaser002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PREVIEW OF "), _c('em', [_vm._v("ADRIFT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-ad-card"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/adcard"
    }
  }, [_vm._v("BY JAMIE SAWYER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "Newsletters"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/newsletterOrbit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ORBIT NEWSLETTER")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0